<template>
  <div v-if="getTools.length > 0">
    <div class="productTools__toolsTitle">Tools</div>
    <div class="productTools__midWidthDivider" />
    <div
      class="productTools__toolsContent"
      :key="index"
      v-for="(tool, index) in getTools"
    >
      <a
        class="productTools__toolsText"
        :href="tool.ToolLink.Url"
        :target="tool.ToolLink.Target"
      >
        {{ tool.ToolTitle }}<i class="material-icons">keyboard_arrow_right</i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("product", ["getProductSeries"]),
    ...mapGetters("enhancedproduct", [
      "getEnhancedTools",
      "getEnhancedProductSeries"
    ]),
    getTools() {
      if (this.getProductSeries && this.getProductSeries.Tools)
        return this.getProductSeries.Tools;
      else if (this.getEnhancedProductSeries && this.getEnhancedTools)
        return this.getEnhancedTools;
      else return [];
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.productTools {
  display: block;
  margin-top: 19px;
  margin-bottom: 20px;

  @include media-breakpoint-up(md) {
    margin-top: 17px;
    margin-bottom: 24px;
    font-size: 20px;
  }

  @include media-breakpoint-up(lg) {
    margin-top: 15px;
    margin-bottom: 42px;
  }

  &__midWidthDivider {
    display: block;
    height: 3px;
    background: $secondary-300;
    border-radius: 0px;
    width: 100%; /* vw fallback for ie*/
    position: relative;
    margin-bottom: 20px;
    @include media-breakpoint-up(md) {
      margin-bottom: 20px;
    }
  }

  &__toolsTitle {
    font-family: $body;
    color: $black-66;
    font-size: 16px;
    letter-spacing: $letter-spacing-xs;
    text-align: left;
    padding-bottom: 2px;
    margin-top: 15px;
    font-weight: normal;

    @include media-breakpoint-up(md) {
      padding-bottom: 4px;
      margin-top: 18px;
    }

    @include media-breakpoint-up(lg) {
      margin-top: 20px;
      width: 34%;
      font-size: 20px;
    }
  }

  &__toolsContent {
    font-family: $body;
    font-size: 16px;
    letter-spacing: $letter-spacing-xs;
    text-align: left;
    color: $primary;
    margin-bottom: 16px;
    i {
      font-size: 16px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 20px;
    }
  }

  &__toolsText {
    &:hover {
      text-decoration: underline;
      text-decoration-color: $primary;
      text-underline-offset: 5px;
    }
  }
}
</style>
